import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { YesNoDialogData } from 'src/app/core/models/dialog-data/yes-no-dialog-data.interface';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
  styleUrls: ['./yes-no-dialog.component.scss'],
})
export class YesNoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<YesNoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: YesNoDialogData
  ) {}

  onNoClick(): void {
    if (this.data.onNoClicked) {
      this.data.onNoClicked();
    }
    this.dialogRef.close('no');
  }

  onYesClick(): void {
    if (this.data.onYesClicked) {
      this.data.onYesClicked();
    }
    this.dialogRef.close('yes');
  }
}
